import { useState } from 'react';
import { TransactionTypeSelector, type TransactionType } from './TransactionTypeSelector';
import { IncomeForm } from './IncomeForm';
import { ExpenseForm } from './ExpenseForm';
import { TransferForm } from './TransferForm';

interface NewTransactionFormProps {
  onSuccess?: () => void;
  onCancel?: () => void;
}

export function NewTransactionForm({ onSuccess, onCancel }: NewTransactionFormProps) {
  const [selectedType, setSelectedType] = useState<TransactionType | null>(null);

  const handleTypeSelect = (type: TransactionType) => {
    setSelectedType(type);
  };

  const handleBack = () => {
    setSelectedType(null);
  };

  const handleFormSuccess = () => {
    setSelectedType(null);
    onSuccess?.();
  };

  if (!selectedType) {
    return (
      <TransactionTypeSelector
        onTypeSelect={handleTypeSelect}
        selectedType={selectedType || undefined}
      />
    );
  }

  return (
    <div className="relative">
      {/* Back Button */}
      <div className="flex items-center mb-4 px-6 pt-4">
        <button
          onClick={handleBack}
          className="flex items-center text-telegram-link font-medium hover:opacity-80 transition-opacity"
        >
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Назад
        </button>
      </div>

      {/* Form Content */}
      {selectedType === 'income' && (
        <IncomeForm
          onSuccess={handleFormSuccess}
          onCancel={onCancel}
        />
      )}

      {selectedType === 'expense' && (
        <ExpenseForm
          onSuccess={handleFormSuccess}
          onCancel={onCancel}
        />
      )}

      {selectedType === 'transfer' && (
        <TransferForm
          onSuccess={handleFormSuccess}
          onCancel={onCancel}
        />
      )}
    </div>
  );
}